export default __webpack_public_path__ + "static/media/bg-value-Efficiencies.bac16b9e.jpg";